'use es6';

let _ = t => t,
    _t;

import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import breakpoint from '../../utils/responsiveBreakpoints';
const StickyContainer = styled.div.withConfig({
  displayName: "StickyContainer",
  componentId: "sc-6c3haw-0"
})(["position:sticky;top:0;z-index:100;background:", ";display:flex;justify-content:space-around;box-shadow:0 2px 4px rgba(0,0,0,0.1);"], OLAF);
export const Mon569TabsStickyContainer = styled.div.withConfig({
  displayName: "StickyContainer__Mon569TabsStickyContainer",
  componentId: "sc-6c3haw-1"
})(["position:sticky;top:-1px;z-index:100;background:", ";width:100%;padding-top:10px;box-shadow:", ";", ";"], OLAF, ({
  isIntersecting
}) => !isIntersecting ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'unset', breakpoint.cs(_t || (_t = _`
    display: none;
  `)));
export default StickyContainer;